<template>
  <mf-card-container class="mt-4 date-card" title="Lojas">
    <p>Lojas participantes da campanha de cupom:</p>
    <mf-select-units-dialog
      outlined
      :selected-units.sync="campaign.units"
      :unit-error="validations.campaign.units && validations.campaign.units.$error"
      :units="units"
      :tag-list="tagList"
      :group-list="unitsGroups"
      :disabled="disableFields"
      hide-ecommerce-configuration
    />
  </mf-card-container>
</template>

<script>
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
export default {
  name: 'CouponDiscountDate',
  components: {},
  props: {
    campaign: {
      type: Object,
      default: () => {},
    },
    validations: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(['units', 'tagList', 'unitsGroups']),
    disableFields() {
      return ['FINISHED', 'ACTIVE'].includes(this.campaign.status)
    },
    todayDate() {
      return DateTime.now().toFormat('yyyy-MM-dd')
    },
    errorSendDate() {
      if (!this.validations.campanha || !this.validations.campanha.start_date) return ''
      if (this.validations.campanha.start_date.$error) {
        if (!this.validations.campanha.start_date.required) return 'Selecione uma data de envio.'
        else if (this.campanha.status !== 'active' && !this.validations.campanha.start_date.isFuture) return 'A data de envio deve ser no futuro.'
      }
      if (!this.validations.campanha || !this.validations.campanha.end_date) return ''
      if (this.validations.campanha.end_date.$error) return 'Período inválido'
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.date-card {
  .period-title {
    font-weight: 600;
    color: $cinza-d10;
    font-size: 16px;
  }
}

.w-50 {
  max-width: 50%;
}

.mf-toggle {
  ::v-deep label {
    color: $cinza-d10 !important;
    font-weight: 600 !important;
    font-size: 16px !important;
  }
}

p {
  color: $cinza-0;
  font-size: 14px;
  line-height: 20px;
  max-width: 480px;
}

.validate-in-days {
  max-width: 170px;
}
</style>
